import { render } from "./VersionAlert.vue?vue&type=template&id=1f6cc59f"
import script from "./VersionAlert.vue?vue&type=script&lang=js"
export * from "./VersionAlert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jakubluszczek/Documents/Projekty/honesty-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__